import {createAction, handleActions} from 'redux-actions';
import {Api} from "../../api/api";
import {logout, onForbidden} from '../account/login';
import _ from 'lodash';
import {getContinentByCountry} from "../common/location";
import {
    fetchSubmitForm,
    fetchSubmitFormFailed,
    fetchSubmitFormSuccess
} from "../common/submitForm";
import { hideModal } from '../common/activeModal';

//- Actions
export const onSetNextOrg = () => (dispatch, getState) => {
    let list = getNotValidatedOrgsData(getState());
    let currentPage = getCurrentPageForNotValidatedOrgs(getState());

    dispatch(incrementNumberOfSkippedOrgs());

    if (!_.isNil(list) && list.length > 0) {
        let currentIndex = getCurrentOrgIndex(getState());
        if (currentIndex < list.length - 1) {
            dispatch(setCurrentOrg(currentIndex + 1));
            dispatch(fetchGetNotValidatedOrgs(currentPage));
        } else {
            let totalPages = getTotalPagesForNotValidatedOrgs(getState());
            if (currentPage < totalPages - 1) {
                dispatch(setCurrentOrg(0));
                dispatch(fetchGetNotValidatedOrgs(currentPage + 1));
            } else {
                dispatch(setCurrentOrg(null));
            }
        }
    }
};

export const incrementNumberOfValidatedOrgs = createAction('NUMBER_OF_VALIDATED_ORGS_INCREMENT');
export const incrementNumberOfSkippedOrgs = createAction('NUMBER_OF_SKIPPED_ORGS_INCREMENT');
export const setNumberOfSkippedOrgs = createAction('NUMBER_OF_SKIPPED_ORGS_SET');

export const onValidateOrgSuccess = () => (dispatch, getState) => {
    dispatch(fetchSubmitFormSuccess());
    dispatch(fetchGetNotValidatedOrgs(getCurrentPageForNotValidatedOrgs(getState())));
    dispatch(incrementNumberOfValidatedOrgs());
    dispatch(hideModal());
};

export const onValidateOrg = createAction(
    'FETCH_VALIDATE_ORG',
    (id) => Api.updateOrganizationValidatedState(id, true),
    () => ({
        apiCall: true,
        onSuccess: onValidateOrgSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchValidateOrg = (id) => (dispatch, getState) => {
    dispatch(fetchSubmitForm());
    dispatch(onValidateOrg(id));
    let currentIndex = getCurrentOrgIndex(getState());
    dispatch(setCurrentOrg(currentIndex + 1));
};

export const setCurrentOrg = createAction('CURRENT_ORG_SET', index => index);
export const startOrgValidation = (id) => (dispatch, getState) => {
    let index = getOrgIndexById(getState(), id);
    let currentPage = getCurrentPageForNotValidatedOrgs(getState());
    let skipped = (currentPage * 10) + index;
    dispatch(setNumberOfSkippedOrgs(skipped));
    dispatch(setCurrentOrg(index));
    dispatch(cleanValidatedStatus());
};
export const cleanValidatedStatus = createAction('VALIDATED_STATUS_CLEAN');

export const fetchGetValidatedOrgsFailed = createAction('FETCH_GET_VALIDATED_ORGS_FAILED');
export const fetchGetNotValidatedOrgsFailed = createAction('FETCH_GET_NOT_VALIDATED_ORGS_FAILED');
export const fetchGetValidatedOrgsSuccess = createAction('FETCH_GET_VALIDATED_ORGS_SUCCESS');
export const fetchGetNotValidatedOrgsSuccess = createAction('FETCH_GET_NOT_VALIDATED_ORGS_SUCCESS');
export const onGetOrgsSuccess = (validated) => (data) => (dispatch, getState) => {
    let isEmpty = data.empty;
    let currentPage = data.number;
    if ((!isEmpty && currentPage !== 0) || currentPage === 0) {
        dispatch(validated ? fetchGetValidatedOrgsSuccess(data) : fetchGetNotValidatedOrgsSuccess(data));
    } else {
        let countryFilter = getCountryFilter(getState());
        dispatch(validated ? fetchGetValidatedOrgs(currentPage - 1, countryFilter) : fetchGetNotValidatedOrgs(currentPage - 1, countryFilter));
    }
};

export const onUpdateValidatedOrgs = () => (dispatch, getState) => {
    let currentPage = getCurrentPageForValidatedOrgs(getState());
    let countryFilter = getCountryFilter(getState());
    dispatch(fetchGetValidatedOrgs(currentPage, countryFilter));
};

export const fetchGetValidatedOrgs = createAction(
    'FETCH_GET_VALIDATED_ORGS',
    (page, countryCode, name) => Api.getOrgs(true, page, countryCode, name),
    () => ({
        apiCall: true,
        onSuccess: onGetOrgsSuccess(true),
        onFail: fetchGetValidatedOrgsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetNotValidatedOrgs = createAction(
    'FETCH_GET_NOT_VALIDATED_ORGS',
    (page) => Api.getOrgs(false, page),
    () => ({
        apiCall: true,
        onSuccess: onGetOrgsSuccess(false),
        onFail: fetchGetNotValidatedOrgsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onRegisterOrganization = createAction(
    'FETCH_REGISTER_ORG',
    (data) => Api.registerOrganization(data),
    () => ({
        apiCall: true,
        onSuccess: onRegisterOrganizationSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchRegisterOrganization = (data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onRegisterOrganization(data));
};
export const onRegisterOrganizationSuccess = () => dispatch => {
    dispatch(fetchSubmitFormSuccess());
    dispatch(hideModal());
};

export const onEditOrgSuccess = () => (dispatch, getState) => {
    let orgData = getOrganizationData(getState());
    if (!_.isNil(orgData)) {
        dispatch(fetchGetOrgDataById(orgData.id));
    }
    dispatch(fetchSubmitFormSuccess());
};

export const fetchChangeOrgBalance = (id, data) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(onFetchChangeOrgBalance(id, data));
};
export const onFetchChangeOrgBalance = createAction(
    'FETCH_CHANGE_ORG_BALANCE',
    (id, data) => Api.changeOrganizationBalance(id, data),
    () => ({
        apiCall: true,
        onSuccess: fetchChangeOrgBalanceSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchChangeOrgBalanceSuccess = () => (dispatch) => {
    dispatch(hideModal());
    dispatch(onUpdateValidatedOrgs());
};

export const fetchUpdateOrgPrice = (id, data) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(onUpdateOrgFinancialData(id, data));
};

export const onUpdateOrgGeneralData = createAction(
    'FETCH_EDIT_ORG',
    (id, data) => Api.updateOrganizationGeneralData(id, data),
    () => ({
        apiCall: true,
        onSuccess: onEditOrgSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onUpdateOrgFinancialData = createAction(
    'FETCH_EDIT_ORG',
    (id, data) => Api.updateOrganizationFinancialData(id, data),
    () => ({
        apiCall: true,
        onSuccess: onEditOrgSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchEditOrg = (id, data) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(onUpdateOrgGeneralData(id, data));
};

export const onChangeAnchorBySysAdmin = createAction(
    'FETCH_EDIT_ANCHOR',
    (orgId, anchorData) => Api.changeAnchorBySysAdmin(orgId, anchorData),
    () => ({
        apiCall: true,
        onSuccess: onEditOrgSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchChangeAnchorBySysAdmin = (orgId, anchorData) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onChangeAnchorBySysAdmin(orgId, anchorData));
};

export const fetchGetOrgDataByIdFailed = createAction('FETCH_GET_ORG_DATA_BY_ID_FAILED');
export const fetchGetOrgDataByIdSuccess = createAction('FETCH_GET_ORG_DATA_BY_ID_SUCCESS');
export const fetchGetOrgDataById = (id) => dispatch => {
    if (!_.isNil(id) && id !== '') {
        dispatch(onGetOrgDataById(id));
    } else {
        dispatch(fetchGetOrgDataByIdFailed("ID_IS_NULL"))
    }
};
export const onGetOrgDataById = createAction(
    'FETCH_GET_ORG_DATA_BY_ID',
    (id) => Api.getOrganizationDataById(id),
    () => ({
        apiCall: true,
        onSuccess: fetchGetOrgDataByIdSuccess,
        onFail: fetchGetOrgDataByIdFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchGetOrgDataForValidateById = (id) => dispatch => {
    dispatch(clearOrgData());
    dispatch(fetchGetOrgDataById(id));
};

export const clearOrgData = createAction('CLEAR_ORG_DATA');

export const EDU_ORG = 'EDU_ORG';
export const COMPANY = 'COMPANY';

export const LABEL_PATH_BY_ORG_TYPE = {
    'EDU_ORG': 'edu_org_label',
    'COMPANY': 'company_label'
};

export const onUpdateNotValidatedOrgSuccess = (data) => dispatch => {
    dispatch(fetchSubmitFormSuccess());
    dispatch(fetchGetOrgDataByIdSuccess(data));
};
export const onUpdateNotValidatedOrgGeneralData = createAction(
    'FETCH_UPDATE_NOT_VALIDATED_ORG',
    (id, data) => Api.updateOrganizationGeneralData(id, data),
    () => ({
        apiCall: true,
        onSuccess: onUpdateNotValidatedOrgSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchUpdateNotValidatedOrgGeneralData = (id, data) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(onUpdateNotValidatedOrgGeneralData(id, data));
};

export const onChangeAnchorBySysAdminForNotValidatedOrgSuccess = (data) => dispatch => {
    dispatch(fetchSubmitFormSuccess());
    dispatch(fetchGetOrgDataByIdSuccess(data));
};
export const onFetchChangeAnchorBySysAdminForNotValidatedOrg = createAction(
    'FETCH_CHANGE_ANCHOR_BY_SA_NOT_VALIDATED_ORG',
    (id, data) => Api.changeAnchorBySysAdmin(id, data),
    () => ({
        apiCall: true,
        onSuccess: onChangeAnchorBySysAdminForNotValidatedOrgSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchChangeAnchorBySysAdminForNotValidatedOrg = (id, data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onFetchChangeAnchorBySysAdminForNotValidatedOrg(id, data));
};

export const resetTotalElementsForNotValidated = createAction('RESET_TOTAL_ELEMENTS_FOR_NOT_VALIDATED');

export const setCountryFilter = createAction('COUNTRY_FILTER_SET');

export const fetchRemoveOrgSuccess = (validated) => () => (dispatch, getState) => {
    dispatch(fetchSubmitFormSuccess());
    if (validated) {
        let countryFilter = getCountryFilter(getState());
        let currentPage = getCurrentPageForValidatedOrgs(getState());
        dispatch(fetchGetValidatedOrgs(currentPage, countryFilter));
    } else {
        let currentPage = getCurrentPageForNotValidatedOrgs(getState());
        dispatch(fetchGetNotValidatedOrgs(currentPage))

    }
}

export const onFetchRemoveOrg = (validated) => createAction(
    'FETCH_REMOVE_ORG',
    (id) => Api.removeOrg(id),
    () => ({
        apiCall: true,
        onSuccess: fetchRemoveOrgSuccess(validated),
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchMarkOrgAsBava = (id) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onFetchMarkOrgAsBava(id))
}

export const fetchRemoveOrgBavaFlag = () => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onFetchRemoveBavaFlag());
}

export const onFetchMarkOrgAsBava = createAction(
  'FETCH_MARK_ORG_AS_BAVA',
  (id) => Api.markOrgAsBava(id),
  () => ({
      apiCall: true,
      onSuccess: onEditOrgSuccess,
      onFail: fetchSubmitFormFailed,
      onUnauthorized: logout,
      onForbidden: onForbidden
  })
);

export const onFetchRemoveBavaFlag = createAction(
  'FETCH_REMOVE_BAVA_FLAG',
  () => Api.removeBavaFlag(),
  () => ({
      apiCall: true,
      onSuccess: onEditOrgSuccess,
      onFail: fetchSubmitFormFailed,
      onUnauthorized: logout,
      onForbidden: onForbidden
  })
);

//- State
const initialState = {
    validatedOrgs: null,
    notValidatedOrgs: null,
    error: null,
    organizationData: null,
    currentPageForValidated: null,
    currentPageForNotValidated: null,
    totalPagesForValidated: null,
    totalPagesForNotValidated: null,
    totalElementsForNotValidated: null,
    currentOrgIndex: null,
    validated: 0,
    skipped: 0,
    leftNumber: null,
    fetching: false,
    organizationFetching: false,
    countryFilter: null
};

//- Reducers
export default handleActions({
    FETCH_GET_VALIDATED_ORGS: (state) => {
        return {
            ...state,
            validatedOrgs: null,
            currentPageForValidated: null,
            totalPagesForValidated: null,
            totalPagesForNotValidated: null,
            error: null,
            fetching: true
        };
    },
    FETCH_GET_NOT_VALIDATED_ORGS: (state) => {
        return {
            ...state,
            notValidatedOrgs: null,
            currentPageForNotValidated: null,
            totalPagesForNotValidated: null,
            error: null,
            fetching: true,
            leftNumber: null
        };
    },
    FETCH_GET_VALIDATED_ORGS_FAILED: (state, action) => {
        return {
            ...state,
            validatedOrgs: null,
            currentPageForValidated: null,
            totalPagesForValidated: null,
            error: action.payload,
            fetching: false
        };
    },
    FETCH_GET_NOT_VALIDATED_ORGS_FAILED: (state, action) => {
        return {
            ...state,
            notValidatedOrgs: null,
            currentPageForNotValidated: null,
            totalPagesForNotValidated: null,
            totalElementsForNotValidated: null,
            error: action.payload,
            fetching: false
        };
    },
    FETCH_GET_VALIDATED_ORGS_SUCCESS: (state, action) => {
        return {
            ...state,
            validatedOrgs: action.payload.content,
            currentPageForValidated: action.payload.number,
            totalPagesForValidated: action.payload.totalPages,
            error: null,
            fetching: false
        };
    },
    FETCH_GET_NOT_VALIDATED_ORGS_SUCCESS: (state, action) => {
        return {
            ...state,
            notValidatedOrgs: action.payload.content,
            currentPageForNotValidated: action.payload.number,
            totalPagesForNotValidated: action.payload.totalPages,
            totalElementsForNotValidated: state.totalElementsForNotValidated || action.payload.totalElements,
            error: null,
            fetching: false,
            leftNumber: action.payload.totalElements
        };
    },
    FETCH_GET_ORG_DATA_BY_ID: (state) => {
        return {...state, error: null, organizationFetching: true};
    },
    FETCH_GET_ORG_DATA_BY_ID_FAILED: (state, action) => {
        return {...state, organizationData: null, error: action.payload, organizationFetching: false};
    },
    FETCH_GET_ORG_DATA_BY_ID_SUCCESS: (state, action) => {
        return {...state, organizationData: action.payload, error: null, organizationFetching: false};
    },
    CURRENT_ORG_SET: (state, action) => {
        return {...state, currentOrgIndex: action.payload};
    },
    VALIDATED_STATUS_CLEAN: (state) => {
        return {...state, validated: 0};
    },
    NUMBER_OF_SKIPPED_ORGS_SET: (state, action) => {
        return {...state, skipped: action.payload};
    },
    NUMBER_OF_SKIPPED_ORGS_INCREMENT: (state) => {
        return {...state, skipped: state.skipped + 1};
    },
    NUMBER_OF_VALIDATED_ORGS_INCREMENT: (state) => {
        return {...state, validated: state.validated + 1};
    },
    CLEAR_ORG_DATA: (state) => {
        return {...state, organizationData: null};
    },
    RESET_TOTAL_ELEMENTS_FOR_NOT_VALIDATED: (state) => {
        return {...state, totalElementsForNotValidated: null};
    },
    COUNTRY_FILTER_SET: (state, action) => {
        return {...state, countryFilter: action.payload};
    }
}, initialState);

//- Selectors
export const getOrgs = state => state.organizations;

export const loadingOrgs = state => getOrgs(state).fetching;

export const loadingOrg = state => getOrgs(state).organizationFetching;

export const getFetchingErrorOrg = state => getOrgs(state).error;

export const getCurrentPageForValidatedOrgs = state => getOrgs(state).currentPageForValidated;

export const getCurrentPageForNotValidatedOrgs = state => getOrgs(state).currentPageForNotValidated;

export const getTotalPagesForValidatedOrgs = state => getOrgs(state).totalPagesForValidated;

export const getTotalPagesForNotValidatedOrgs = state => getOrgs(state).totalPagesForNotValidated;

export const getValidatedOrgsData = state => getOrgsData(state, true);

export const getValidatedOrgsPaymentsData = state => getOrgsPaymentsData(state, true);

export const getOrgsPaymentsData = (state, validated) => {
    let data = validated ? getOrgs(state).validatedOrgs : getOrgs(state).notValidatedOrgs;
    if (_.isNil(data)) {
        return null;
    }

    return _.map(data, org => ({
        id: org.id,
        orgType: org.type,
        orgName: org.name,
        active: org.anchor.active,
        balance: org.balance,
        paidTillDate: org.paidTill,
        anchorName: _.isNil(org.anchor.identityAlias) || _.isNil(org.anchor.identityAlias.firstName) || _.isNil(org.anchor.identityAlias.lastName) ?
            org.anchor.email : org.anchor.identityAlias.firstName + " " + org.anchor.identityAlias.lastName,
        anchorEmail: org.anchor.email,
        location: org.address.countryCode
    }));
};

export const getNotValidatedOrgsData = state => getOrgsData(state, false);

export const getOrgsData = (state, validated) => {
    let data = validated ? getOrgs(state).validatedOrgs : getOrgs(state).notValidatedOrgs;
    if (_.isNil(data)) {
        return null;
    }

    return _.map(data, org => ({
        id: org.id,
        anchorName: _.isNil(org.anchor.identityAlias) || _.isNil(org.anchor.identityAlias.firstName) || _.isNil(org.anchor.identityAlias.lastName) ?
            org.anchor.email : org.anchor.identityAlias.firstName + " " + org.anchor.identityAlias.lastName,
        anchorEmail: org.anchor.email,
        active: org.anchor.active,
        location: org.address.countryCode,
        orgName: org.name,
        generalDataValidated: org.generalDataValidated,
        financialDataValidated: org.financialDataValidated,
        orgType: org.type,
        isBava: org.bava
    }));
};

export const getOrganizationData = (state) => getOrgs(state).organizationData;

export const getOrganizationDataForRequest = (state) => {
    let data = _.cloneDeep(getOrganizationData(state));

    delete data.balance;
    delete data.pricing;

    return data;
};

export const getOrganizationPriceDataForRequest = (state) => {
    return {
        pricing: getOrganizationData(state).pricing,
        balance: getOrganizationData(state).balance
    };
};

export const getOrgDataToEdit = (state) => {
    let data = getOrganizationData(state);
    if (_.isNil(data)) {
        return null;
    }

    return {
        orgId: data.id,
        orgType: data.type,
        orgName: data.name,
        orgDomain: data.domain,
        orgVatNumber: data.vatNumber,
        companyCode: data.companyCode,
        orgContinent: getContinentByCountry(data.address.countryCode, state),
        orgCountry: data.address.countryCode,
        orgEmployeeCount: data.employeeCount,
        orgCity: data.address.city,
        orgPostal: data.address.postal,
        orgStreet: data.address.street,
        anchorFirstName: data.anchor.identityAlias.firstName,
        anchorLastName: data.anchor.identityAlias.lastName,
        anchorEmail: data.anchor.email,
        hasIVs: data.hasIVs,
        verifiesIdentities: data.verifiesIdentities,
        providesMoocCertificates: data.providesMoocCertificates,
        presetId: data.pricing.pricingPreset.id,
        generalDataValidated: data.generalDataValidated,
        financialDataValidated: data.financialDataValidated,
        isBava: data.bava,
    };
};

export const getOrgPermissionsData = (state) => {
    let data = getOrganizationData(state);
    if (_.isNil(data)) {
        return null;
    }

    return {
        hasIVs: data.hasIVs,
        verifiesIdentities: data.verifiesIdentities,
        providesMoocCertificates: data.providesMoocCertificates
    };
};

export const getOrgFinanceData = (state) => {
    let data = getOrganizationData(state);
    if (_.isNil(data)) {
        return null;
    }

    return {
        balance: data.balance.amount,
        balanceCurrency: data.balance.currency,
        presetId: data.pricing.pricingPreset.id,
        paidTillDate: data.paidTill,
        annualFee: data.pricing.annualFee || data.pricing.pricingPreset.annualFee,
        consentRequestFee: data.pricing.consentRequestFee || data.pricing.pricingPreset.consentRequestFee,
        deviationDate: data.pricing.validTill,
        deviationDateForever: (!_.isNil(data.pricing.annualFee) || !_.isNil(data.pricing.consentRequestFee)) && _.isNil(data.pricing.validTill),
        financialData: data.financialData || ""
    };
};

export const getOrgDataToEditPayments = (state) => {
    let data = getOrganizationData(state);
    if (_.isNil(data)) {
        return null;
    }

    return {
        orgType: data.type,
        orgName: data.name,
        orgContinent: getContinentByCountry(data.address.countryCode, state),
        orgCountry: data.address.countryCode,
        anchorName: _.isNil(data.anchor.identityAlias) || _.isNil(data.anchor.identityAlias.firstName) || _.isNil(data.anchor.identityAlias.lastName) ?
            data.anchor.email : data.anchor.identityAlias.firstName + " " + data.anchor.identityAlias.lastName,
        anchorEmail: data.anchor.email
    };
};

export const getOrgIndexById = (state, id) => {
    let notValidatedOrgsList = getOrgs(state).notValidatedOrgs;

    if (_.isNil(notValidatedOrgsList)) {
        return null;
    }

    let index = _.findIndex(notValidatedOrgsList, org => org.id === id);

    if (index < 0) {
        return null;
    }

    return index;
};

export const getCurrentOrgIndex = state => getOrgs(state).currentOrgIndex;

export const getCurrentOrgId = state => {
    let index = getOrgs(state).currentOrgIndex;
    let ids = _.map(getNotValidatedOrgsData(state), org => org.id);

    if (index >= ids.length) {
        return null;
    }
    return ids[index];
};

export const getLeftOrgsNumber = state => getOrgs(state).leftNumber;

export const getNumberOfValidatedOrgs = state => getOrgs(state).validated;

export const getNumberOfSkippedOrgs = state => getOrgs(state).skipped;

export const getTotalNumberOfNotValidatedOrgs = state => getOrgs(state).totalElementsForNotValidated;

export const getOrgName = (state) => {
    let data = getOrganizationData(state);
    if (_.isNil(data)) {
        return null;
    }

    return data.name;
};

export const getCountryFilter = state => getOrgs(state).countryFilter


// WEBPACK FOOTER //
// ./src/reducers/organization/organizations.js